import { connect } from "react-redux";

import { fetchPosts } from "../../../store/action/postAction";
import { useEffect } from "react";
import TablePosts from "./table-posts";
import Main from "../../shared/main";
import { Link } from "react-router-dom";
import { URL } from "../../../routers/constants";
const _ = require('lodash');

const PostsList = (props) => {
  const { page, fetchPosts } = props;

  useEffect(() => {
    if (!_.isEmpty(page)) {
      fetchPosts();
    }
  }, [page]);
 
  return (
    <div id="bot-scene-container" className="">
      <div id="bot-scene-content" className="scroll-light">
        <div className="app-v2-header-wrapper has-subtitle has-extra">
          <div className="app-v2-header-left">
            <span className="app-v2-header-title">Danh sách bài viết</span><span
              className="app-v2-header-subtitle">
              Dễ dàng quản lý bài viết và tăng tỷ lệ tương tác, thu hút khách hàng với các nội
              dung mẫu hấp dẫn. <a
                href=""
                target="_blank">Tìm hiểu thêm</a></span></div>
          <div className="app-v2-header-extra-wrapper">
            <div className="app-v2-header-extra-item">
              <Link to={'/posts_comments/posts/postlist/123'}>
                <button type="button" className="app-btn app-btn-primary app-v2-gtm-auto-sequence-new">
                  <div className="svg-next-icon mr5 color-white ic-add-outline">
                  </div>Tạo bài viết
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="app-v2-layout-content" style={{ background: 'white' }}>
          <div className="sequence-table-container">
            <div className="app-v2-table-container">
              <div>
                <div className="app-v2-table-filter">
                  <div className="hrs-filter-container-master">
                    <div className="hrs-filter-container">
                      <div className="hrs-filter-wrapper">
                        <div className="hrs-btn-open-filter">
                          <div className="svg-next-icon icon-filter">
                          </div><span>Bộ lọc tìm kiếm</span>
                        </div>
                      </div>
                      <div className="hrs-filter-search-wrapper"><svg width="16" height="16" viewBox="0 0 16 16">
                        <path fill="#8993A4" fillRule="evenodd"
                          d="M6.8 13.6a6.8 6.8 0 115.34-2.59l3.626 3.624a.8.8 0 01-1.132 1.132L11.01 12.14A6.77 6.77 0 016.8 13.6zm3.728-3.175a.817.817 0 00-.103.103 5.2 5.2 0 11.102-.102z"
                          clipRule="evenodd"></path>
                      </svg><input className="hrs-filter-input-search" placeholder="Tìm kiếm theo PostID" value="" /></div>
                    </div>
                    <div className="hrs-condition-container mt10"></div>
                  </div>
                </div>
                <div>
                  <div className="app-table-container app-scrollbar">
                    <TablePosts />
                  </div>
                </div>
                <div className="app-v2-table-footer-wrapper">
                  <div className="">
                    <div className="app-pagination ">
                      <div className="app-pagination--options">
                        <div className="app-pagination-dropdown">
                          <div className="app-pagination-dropdown--text">Hiển thị</div>
                          <div className="app-pagination-dropdown--btn">
                            <div className="app-pagination-dropdown--number">10</div>
                            <div className="app-pagination-dropdown--icon"><svg
                              className="app-svg-inline-block app-svg-next-icon-rotate-90" width="16px" height="16px"
                              viewBox="0 0 16 16">
                              <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z"></path>
                            </svg></div>
                          </div>
                        </div>
                      </div>
                      <ul className="app-pagination--listpage">
                        <li className="app-pagination-total-text">Đang hiển thị 1-1 / 1 </li>
                        <li className="app-pagination--item app-pagination--item-active"><a>1</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div></div>
            </div>
            <div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { page } = state;
  return {
    page
  };
};

export default connect(mapStateToProps, {
  fetchPosts
})(PostsList);